<template>
    <div>
        <backTitleBar :isBackHome="true"></backTitleBar>
        <div class="page-flex" style="height:100%">
            <div class="page-data">
                 <div class="page-data-top">
                     <div class="page-data-div" :class="tabTimeActive == item.value ?'active':''" v-for="item in tabTimeList" :key="item.value" @click="tabTimeActive = item.value">{{item.name}}</div>
                 </div>
                 <DatePicker v-show="tabTimeActive == 3" :editable=false @on-change="timeChange2" type="date"  :value="time" class="page-data-time"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>
                 <DatePicker v-show="tabTimeActive == 2" :editable=false @on-change="timeChange2" type="month" :value="time" class="page-data-time"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>
                 <DatePicker v-show="tabTimeActive == 1" :editable=false @on-change="timeChange2" type="year"  :value="time" class="page-data-time"  placeholder="请选择日期" style="width: 3.47rem"></DatePicker>

                 <div class="card-tab">
                    <div class="tab-item" :class="tabActive == item.value ?'active':''" v-for="item in tabList" :key="item.value" @click="tabClick(item.value)">{{item.name}}</div>
                </div>
            </div>

            <div class="page-user">
               <div class="card">
                
                <div v-show="tabActive == 0">
                    <div class="card-table-header">
                        <div class="table-index">商品名称</div>
                        <div class="table-main">订单量</div>
                        <div class="table-number">销售额</div>
                    </div>
                    <ul>
                       <li class="li-item" v-for="(item,$index) in saleList" :key="$index" @click="$router.push({name:'onlyProduct',query:{qryProdName:item.productName,
                       orderNum:item.orderNum,totalSaleMoney:item.totalSaleMoney,time:time,dimension:tabTimeActive}})">
                            <div class="table-index">{{item.productName}}</div>
                            <div class="table-main">{{item.orderNum}}</div>
                            <div class="table-number">{{item.totalSaleMoney}}</div>
                        </li>
                    </ul>
                </div>

                <div v-show="tabActive == 1">
                    <div class="card-table-header">
                        <div class="table-index">设备名称</div>
                        <div class="table-main">订单量</div>
                        <div class="table-number">销售额</div>
                    </div>
                    <ul >
                        <li class="li-item" v-for="(item,$index) in saleList" :key="$index" @click="$router.push({name:'onlyEquipment',query:{qryShopName:item.shopName,
                        orderNum:item.orderNum,totalSaleMoney:item.totalSaleMoney,time:time,dimension:tabTimeActive}})">
                            <div class="table-index">{{item.shopName}}</div>
                            <div class="table-main">{{item.orderNum}}</div>
                            <div class="table-number">{{item.totalSaleMoney}}</div>
                        </li>
                    </ul>
                </div>
                <div style="height: 0.95rem"></div>
            </div>
          </div>
        </div>
        <tabber :tabActive="1"></tabber>
    </div>
</template>

<script>
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryRank} from "@/api/data"
    import tabber from '@/view/data/equipment/index'
    export default {
        name: "rankList2",
        mixins: [routerBack],
        components:{tabber, backTitleBar},
         data() {
            return {
                tabList:[
                    {name:'商品排行',value: 0},
                    {name:'设备排行',value: 1},
                ],
                tabTimeList:[
                    {name:'日',value: 3},
                    {name:'月',value: 2},
                    {name:'年',value: 1}
                ],
                tabActive: 0,
                tabTimeActive: 3,
                saleList: [],
                time: ''
            }
        },
        watch:{
            tabTimeActive(val){
                if(val){

           let temp_date = new Date();
           let temp_year1 = temp_date.getFullYear();
           let temp_month1 = (temp_date.getMonth()+1) > 9 ? (temp_date.getMonth()+1) : "0" + (temp_date.getMonth()+1);
           let temp_day1 = (temp_date.getDate()) > 9 ? (temp_date.getDate()) : "0" + (temp_date.getDate());
           let curTime = temp_year1.toString() + temp_month1.toString() + temp_day1.toString();
           let curTime2 = temp_year1.toString() + temp_month1.toString();
           let curTime3 = temp_year1.toString()
           let time = temp_date.toLocaleDateString().split('/').join('-');
           this.time = val == 3 ? curTime : val == 2 ? curTime2 : curTime3;

                    let params = {
                         qryTime: val == 3 ? curTime : val == 2 ? curTime2 : curTime3,
                         dimension: val,
                         qtype: 0,
                         qryType: this.tabActive,
                         dataType: 0
                      }
                      qryRank(params).then(res=>{
                        if(res.code == 0){
                            this.saleList = res.data.records
                          }
                      })
                  }
            }
        },
        mounted() {
           let _this = this; 
           let temp_date = new Date();
           let temp_year1 = temp_date.getFullYear();
           let temp_month1 = (temp_date.getMonth()+1) > 9 ? (temp_date.getMonth()+1) : "0" + (temp_date.getMonth()+1);
           let temp_day1 = (temp_date.getDate()) > 9 ? (temp_date.getDate()) : "0" + (temp_date.getDate());
           let curTime = temp_year1.toString() + temp_month1.toString() + temp_day1.toString();
           this.time = curTime;

           let params = {
              qryTime: curTime,
              dimension: 3,
              qtype: 0,
              qryType: 0,
              dataType: 0
           }
           qryRank(params).then(res=>{
               if(res.code == 0){
                  this.saleList = res.data.records
               }
           })
        },
        methods: {
           back(){
            console.log(11)
           },
          timeChange2(e){
            if(e){
            this.time = e.split('-').join('');
            let time = e.split('-').join('');
            let params = {
              qryTime: time,
              dimension: this.tabTimeActive,
              qtype: 0,
              qryType: this.tabActive,
              dataType: 0
           }
           qryRank(params).then(res=>{
               if(res.code == 0){
                  this.saleList = res.data.records
               }
             })
            }
           },

           tabClick(e){
             this.tabActive = e;

             let params = {
              qryTime: this.time,
              dimension: this.tabTimeActive,
              qtype: 0,
              qryType: this.tabActive,
              dataType: 0
             }
             qryRank(params).then(res=>{
               if(res.code == 0){
                  this.saleList = res.data.records
               }
             })
          }
      },
        
    }
</script>

<style scoped lang="scss">
    .shop-top{
        padding-top: .25rem;
        display: flex;
        flex-direction: row;
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .25rem;
            margin-left: .4rem;
           
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
    }
    .shop-info{
        padding-left: .4rem;
        padding-top: .2rem;
        padding-bottom: .25rem;
        display: flex;
        flex-direction: row;
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .15rem;
            margin-left: .4rem;
           
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
        .info-item{
            color: #fff;
            .title{
                color: #eee;
                font-size: .28rem;
                line-height: .4rem;
            }
            .number{
                font-size: .68rem;
                line-height: .95rem;
            }
            &:first-child{
                width: 65%;
            }
            &:nth-child(2){
                width: 35%;
            }
        }
    }
    .page-flex{
        background: #eee;
        .page-data{
            position: sticky;
            position: -webkit-sticky;
            top: .9rem;
            width: 100%;
            background: #fff;
            //height: 3rem;
            //border-radius: .24rem;
            // padding-top: 1rem;
        }
        .page-user{
            //padding-top: 2.4rem;
            //margin: .2rem 0;
            background: #fff;
            //height: 8.16rem;
            //border-radius: .24rem;
        }
    }
    .card{
        //width: 7rem;
        //margin: 0 .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .08rem .26rem;
        .card-title{
            font-size: .34rem;
            line-height: .48rem;
            color: #252D46;
            font-weight: bold;
        }
    }
    .card-tab{
            display: flex;
            margin-top: .29rem;
            padding-bottom: .2rem;
            padding-left: .4rem;
            .tab-item{
                margin-right: .5rem;
                font-size: .3rem;
                line-height: .45rem;
                color: #919BA6;
                &.active{
                    position: relative;
                    color: #252D46;
                    &:after{
                        position: absolute;
                        content: '';
                        width: .82rem;
                        height: .06rem;
                        background: #83C221;
                        border-radius: .03rem;
                        bottom: -.15rem;
                        left: 0;
                    }
                }
            }
     }
    .card-table-header{
        margin-top: .25rem;
        display: flex;
        background: #F5F6FA;
        border-radius: .14rem;
        padding: .16rem .2rem;
        font-size: .28rem;
        line-height: .4rem;
        color: #666;
    }
    .table-index{
        width: 2.6rem;
        margin-right: .2rem;
    }
    .table-main{
        flex: 1;
        margin-right: .1rem;
    }
    .table-number{
        width: 1.5rem;
    }
    .li-item{
        display: flex;
        font-size: .32rem;
        line-height: .45rem;
        color: #333;
        padding: .15rem .2rem;
        .table-number{
            color: $org;
        }
    }
    .page-data-time{
        display: block;
        margin: 0 auto;
    }
    .page-data-top{
        width: 94%;
        height: .68rem;
        display: flex;
        flex-direction: row;
        margin: .3rem .24rem;
        border-radius: .12rem;
        border: .03rem solid #83C221;
    }
    .page-data-div{
        flex: auto;
        font-size: .28rem;
        text-align: center;
        line-height: .68rem;
        &:first-child{
          border-right: .03rem solid #83C221;
        }
        &:nth-child(2){
          border-right: .03rem solid #83C221;
        }
        &.active{
            color: #fff;
            background: #83C221;
        }
    }
</style>


// WEBPACK FOOTER //
// rankList.vue?06ecb8c2